import React, { useState, useRef } from 'react';
import { useOutsideClick } from '../../../utils/custom-hooks';

import './dropdown-wrapper.scss';

const DropdownWrapper = ({ children, label, labelImageUrl }) => {
  const [open, setOpen] = useState(false);
  const container = useRef(false);
  useOutsideClick(container, () => setOpen(false));

  const content = open ? (
    <div
      className="dropdown-menu"
      onClick={e => {
        e.stopPropagation();
        setOpen(false);
      }}
    >
      {children}
    </div>
  ) : null;

  const labelImage = labelImageUrl ? (
    <img className="label-img" alt="label-img" src={labelImageUrl} />
  ) : null;

  return (
    <div
      className={`dropdown-wrapper ${open ? 'open' : ''}`}
      ref={node => (container.current = node)}
      onClick={() => setOpen(!open)}
    >
      {content}
      <div className="label">
        <span className="label-text">{label}</span>
        {labelImage}
        <span className={open ? 'arrow-up' : 'arrow-down'} />
      </div>
    </div>
  );
};

export default DropdownWrapper;
